import { SplitOption } from "../types/split-option.model";

export enum SplitType {
    SELECTED_ITEMS = 1,
    SPLIT_EVENLY = 2,
    SPLIT_SELECTED_ITEMS_EVENLY = 3,
    CUSTOM_AMOUNT = 4,
    FULL_AMOUNT = 5
}

export function toSplitType(option: SplitOption): SplitType {
    return SplitType[option];
}